import React, { useEffect, useState,useRef } from 'react';
import DisputeAdminView from '../../views/AdminView/DisputeAdminView';
import {desputeviewbyadmin, useServiceContext} from '../../components/Context/ServiceContext';
const DisputeComponent = () => { 
    const [loading,setLoading]=useState(true);
    const [disputedata,setDisputeData]=useState({});
    const didFetch=useRef(false);
    const {disputeviewbyadmin}=useServiceContext();
    const getData=async()=>{
        try{
           
            const data=await disputeviewbyadmin();
            console.log(data);
            setDisputeData(data);
            setLoading(false);

        }catch(error){
            console.log(error);
        }

    }
    useEffect( ()=>{
        if(!didFetch.current){
            getData();
            didFetch.current=true;
        }
    },[getData]);

    return ( <div> { !loading && <DisputeAdminView />} </div> ); 
} 
export default DisputeComponent;